module.exports = __webpack_public_path__ + "static/media/visa.0b2ccfbc.svg";